import { Card, CircularProgress, Box } from "@mui/material";
import tw from "tailwind-styled-components";

const SampleCard = () => {
    const totalUnits = 632;
    const occupied = 298;
    const vacant = 249;
    const maintenance = 85;

    const percentageOccupied = Math.round((occupied / totalUnits) * 100);
    const percentageVacant = Math.round((vacant / totalUnits) * 100);
    const percentageMaintenance = Math.round((maintenance / totalUnits) * 100);

    return (
        <Card className="p-4 shadow-lg rounded-2xl w-80 mt-5 md:ml-10 lg:ml-10">
            <Heading>Property Name</Heading>
            <Container>
                <div className="space-y-3">
                    <SubHeading>
                        <BlueDot />
                        <SubText>
                            <Value>{occupied}</Value>
                            <PercentageValue>Occupied {percentageOccupied}%</PercentageValue>
                        </SubText>
                    </SubHeading>
                    <SubHeading>
                        <TealDot />
                        <SubText>
                            <Value>{occupied}</Value>
                            <PercentageValue>Vacant {percentageVacant}%</PercentageValue>
                        </SubText>
                    </SubHeading>
                    <SubHeading>
                        <OrangeDot />
                        <SubText>
                            <Value>{occupied}</Value>
                            <PercentageValue>Maintenance {percentageMaintenance}%</PercentageValue>
                        </SubText>
                    </SubHeading>
                </div>


                <Box sx={{ position: "relative", display: "inline-flex" }}>
                    {/* Background Circle */}
                    <CircularProgress
                        variant="determinate"
                        value={100}
                        size={120}
                        thickness={3}
                        sx={{ color: "#e5e7eb" }}
                    />

                    {/* Occupied - Blue */}
                    <CircularProgress
                        variant="determinate"
                        value={percentageOccupied}
                        size={120}
                        thickness={3}
                        sx={{
                            color: "#2563eb",
                            position: "absolute",
                            left: 0,
                            transform: "rotate(0deg)",
                        }}
                    />

                    {/* Vacant - Teal */}
                    <CircularProgress
                        variant="determinate"
                        value={percentageVacant}
                        size={120}
                        thickness={3}
                        sx={{
                            color: "#14b8a6",
                            position: "absolute",
                            left: 0,
                            transform: `rotate(${(percentageOccupied / 100) * 360}deg)`,
                        }}
                    />

                    {/* Maintenance - Orange */}
                    <CircularProgress
                        variant="determinate"
                        value={percentageMaintenance}
                        size={120}
                        thickness={3}
                        sx={{
                            color: "#f97316",
                            position: "absolute",
                            left: 0,
                            transform: `rotate(${((percentageOccupied + percentageVacant) / 100) * 360}deg)`,
                        }}
                    />

                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <span className="text-lg font-semibold">{totalUnits}</span>
                        <span className="text-xs text-gray-500">Total</span>
                    </Box>
                </Box>
            </Container>
        </Card>
    );
};

const Heading = tw.div`flex justify-between items-center font-bold pb-2`;
const SubHeading = tw.div`flex items-center space-x-2`;
const Container = tw.div`flex items-center justify-between mt-4`;
const BlueDot = tw.span`w-3 h-3 bg-blue-500 rounded-full mb-3`;
const TealDot = tw.span`w-3 h-3 bg-teal-400 rounded-full mb-3`;
const OrangeDot = tw.span`w-3 h-3 bg-orange-400 rounded-full mb-3`;
const SubText = tw.div`flex flex-col`;
const Value = tw.span`text-sm font-medium`;
const PercentageValue = tw.span`text-xs text-gray-500`;

export default SampleCard;